import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { DealerOrderPreview } from "../../../queries/usePreviewDealerOrderFromCart";

type DealerOrderNotesProps = {
  data: DealerOrderPreview;
};

export const DealerOrderNotes: FunctionComponent<DealerOrderNotesProps> = ({
  data,
}) => {
  const [language] = useLanguage();

  return (
    <p className="text-ink-2 font-light my-2 md:my-4 text-xs md:text-sm">
      {data.orderNotes[language] ?? data.orderNotes["en"]}
    </p>
  );
};
